import React, { useEffect } from 'react';

/**
 * GT-styled bottom sheet listing pay cycles. Selecting one re-scopes the Home.
 * props: open, onClose, cycles [{id,label,chip,is_finalized,status}], selectedId, onSelect(id|null)
 */
export default function CycleSheet({ open, onClose, cycles, selectedId, onSelect }) {
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prev; };
    }
  }, [open]);

  if (!open) return null;

  const chipStyle = (c) => ({
    fontSize: 11, letterSpacing: 0.4, textTransform: 'uppercase',
    padding: '2px 8px', borderRadius: 999,
    background: c.is_finalized ? '#EFE7DB' : c.status === 'closed_finalizing' ? '#F3E4CE' : '#E4EFE0',
    color: c.is_finalized ? '#6B5A44' : c.status === 'closed_finalizing' ? '#9C6B4A' : '#4a7a4a',
  });

  return (
    <div
      data-testid="cycle-sheet-overlay"
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(20,16,12,0.55)', zIndex: 1000,
               display: 'flex', alignItems: 'flex-end', backdropFilter: 'blur(2px)' }}
    >
      <div
        data-testid="cycle-sheet"
        onClick={(e) => e.stopPropagation()}
        style={{ width: '100%', maxHeight: '72vh', overflowY: 'auto', background: '#F7F2EA',
                 borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: '18px 18px 32px',
                 boxShadow: '0 -8px 30px rgba(0,0,0,0.25)', animation: 'cycleSheetUp 0.28s ease' }}
      >
        <div style={{ width: 40, height: 4, borderRadius: 4, background: '#D8CBB8', margin: '0 auto 16px' }} />
        <div style={{ fontFamily: 'Cormorant, serif', fontSize: 20, color: '#231E1A', marginBottom: 4 }}>Pay cycles</div>
        <div style={{ fontSize: 13, color: '#8a7355', marginBottom: 14 }}>Pick a cycle to see that period.</div>

        {cycles.map((c) => {
          const active = (selectedId ? c.id === selectedId : false);
          return (
            <button
              key={c.id}
              data-testid={`cycle-option-${c.id}`}
              onClick={() => onSelect(c.id)}
              style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                       gap: 10, padding: '13px 14px', marginBottom: 8, borderRadius: 12, cursor: 'pointer',
                       border: active ? '1.5px solid #B0905E' : '1px solid #E5DCCC',
                       background: active ? '#FBF6EE' : '#FFFFFF', textAlign: 'left' }}
            >
              <span style={{ fontFamily: 'Cormorant, serif', fontSize: 17, color: '#231E1A' }}>{c.label}</span>
              <span style={chipStyle(c)}>{c.chip}</span>
            </button>
          );
        })}

        {selectedId && (
          <button
            data-testid="cycle-back-to-current"
            onClick={() => onSelect(null)}
            style={{ marginTop: 8, width: '100%', padding: '12px', borderRadius: 12, border: 'none',
                     background: '#231E1A', color: '#F3EEE7', fontFamily: 'Cormorant, serif', fontSize: 16, cursor: 'pointer' }}
          >
            ← Back to current
          </button>
        )}
      </div>
      <style>{`@keyframes cycleSheetUp { from { transform: translateY(100%); } to { transform: translateY(0); } }`}</style>
    </div>
  );
}
